import * as v from 'valibot';
import { IdSchema, EmailSchema, RoleSchema, TimestampSchema } from './common.js';
export const UserSchema = v.object({
    id: IdSchema,
    email: EmailSchema,
    role: RoleSchema,
    createdAt: TimestampSchema,
    lastLoginAt: v.optional(TimestampSchema),
    deactivatedAt: v.optional(TimestampSchema)
});
export const CreateUserSchema = v.object({
    email: EmailSchema,
    role: RoleSchema
});
export const UpdateUserSchema = v.partial(v.object({
    role: RoleSchema,
    /** When true, archives the user (blocks sign-in and downloads). When false, reactivates. */
    deactivated: v.boolean()
}));
export function isUserDeactivated(user) {
    return user.deactivatedAt != null;
}
//# sourceMappingURL=user.js.map